var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import './index.css';
import * as ajax from '../../app-lib/ajax_proxy';
import "../../components/tree";
import * as echarts from "echarts";
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/first/four', root, {}) || this;
        _this.projectFollow = ko.observable();
        _this.xinxichi = ko.observable();
        _this.file = ko.observable();
        _this.ribao = ko.observable();
        _this.monthSelect = ko.observableArray([]);
        _this.month = ko.observable('');
        _this.departmentUrluser = ko.observable('/api/org/showdepa');
        _this.showdepalist = ko.observable(false);
        _this.depaName = ko.observable('大区范围');
        _this.depaId = ko.observable('');
        _this.areaArr = ko.observableArray([]);
        _this.dateArr = ko.observableArray([]);
        _this.numArr = ko.observableArray([]);
        _this.month.subscribe(function () {
            _this.initLoadArea();
        });
        return _this;
    }
    ;
    HeaderModel.prototype.open = function () {
    };
    //录入量
    HeaderModel.prototype.luru = function () {
        var _this = this;
        this.container.querySelector("#luru").classList.add("active");
        this.container.querySelector("#qianyue").classList.remove("active");
        this.container.querySelector("#baifang").classList.remove("active");
        this.options2.xAxis[0].data = [];
        this.options2.series[0].data = [];
        ajax.get("/api/first/inputer").then(function (d) {
            _this.options2.color[0] = '#ffcd31';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    /// 签约量
    HeaderModel.prototype.qianyue = function () {
        var _this = this;
        this.container.querySelector("#qianyue").classList.add("active");
        this.container.querySelector("#luru").classList.remove("active");
        this.container.querySelector("#baifang").classList.remove("active");
        event.srcElement.parentElement.childNodes;
        this.options2.series[0].data = [];
        this.options2.xAxis[0].data = [];
        ajax.get("/api/first/sign").then(function (d) {
            _this.options2.color[0] = '#7584f6';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    //拜访量
    HeaderModel.prototype.baifang = function () {
        var _this = this;
        this.container.querySelector("#baifang").classList.add("active");
        this.container.querySelector("#luru").classList.remove("active");
        this.container.querySelector("#qianyue").classList.remove("active");
        this.options2.series[0].data = [];
        this.options2.xAxis[0].data = [];
        ajax.get("/api/first/visit").then(function (d) {
            _this.options2.color[0] = '#1ce4ef';
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.options2.xAxis[0].data.push(d.data[0].user[i]);
                _this.options2.series[0].data.push(d.data[1].count[i]);
            }
            _this.mychart2 = echarts.init(_this.container.querySelector('#main2'));
            _this.mychart2.setOption(_this.options2);
        });
    };
    HeaderModel.prototype.duble = function () {
    };
    HeaderModel.prototype.xiala = function (e) {
        if (event.stopPropagation) {
            e.stopPropagation();
            this.showdepalist(true);
            return true;
        }
        else if (window.event) {
            window.event.cancelBubble = true;
            // e.stopPropagation();
            this.showdepalist(true);
            return true;
        }
    };
    HeaderModel.prototype.closedepalist = function (e) {
        this.showdepalist(false);
        return true;
    };
    HeaderModel.prototype.onUserOrgChange = function (data) {
        this.depaName(data.name);
        this.depaId(data.id);
        this.initLoadArea();
        this.showdepalist(false);
    };
    HeaderModel.prototype.initLoadArea = function () {
        var _this = this;
        ajax.get('/api/first/allarea', {
            month: this.month(),
            departmentId: this.depaId()
        }).then(function (d) {
            console.log(d);
            _this.dateArr([]);
            for (var i in d.data.datelist) {
                _this.dateArr.push(d.data.datelist[i] + '日');
            }
            _this.areaArr(d.data.arealist.map(function (p) { return p; }));
            _this.numArr(d.data.numlist.map(function (n) { return n; }));
            _this.initArea(_this.dateArr(), _this.areaArr(), _this.numArr());
        });
    };
    HeaderModel.prototype.checkMonth = function (m) {
        var str = {
            1: '一月',
            2: '二月',
            3: '三月',
            4: '四月',
            5: '五月',
            6: '六月',
            7: '七月',
            8: '八月',
            9: '九月',
            10: '十月',
            11: '十一月',
            12: '十二月'
        };
        if (str[m]) {
            return str[m];
        }
    };
    HeaderModel.prototype.initMonth = function () {
        var m = new Date().getMonth() + 1;
        for (var i = 1; i < m + 1; i++) {
            this.monthSelect.push({
                month: i,
                text: this.checkMonth(i)
            });
        }
    };
    HeaderModel.prototype.loadArea = function () {
        var _this = this;
        return ajax.get('/api/first/allarea', {
            month: this.month(),
            departmentId: 0,
        }).then(function (d) {
            console.log(d);
            _this.dateArr([]);
            for (var i in d.data.datelist) {
                _this.dateArr.push(d.data.datelist[i] + '日');
            }
            _this.areaArr(d.data.arealist.map(function (p) { return p; }));
            _this.numArr(d.data.numlist.map(function (n) { return n; }));
        });
    };
    HeaderModel.prototype.initArea = function (date, area, num) {
        var myChart3 = echarts.init(this.container.querySelector('#main3'));
        var option3 = {
            // title: {
            // 	text: '未来一周气温变化',
            // 	subtext: '纯属虚构'
            // },
            tooltip: {
                trigger: 'axis',
                formatter: '{b}' + "<br/>" + '{a0}:{c0}万㎡' + "<br/>" + '{a1}:{c1}',
            },
            legend: {
                data: ['录入面积', '录入条数'],
                top: '10',
                textStyle: {
                    fontSize: 14,
                    color: '#fff'
                }
            },
            toolbox: {},
            grid: {
                top: '75',
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                splitArea: {
                    show: true
                },
                data: date,
                axisLabel: {
                    textStyle: {
                        fontSize: 14,
                        color: '#fff'
                    }
                },
                axisLine: {
                    lineStyle: {
                        color: "#89c3f8"
                    }
                },
            },
            yAxis: [{
                    type: 'value',
                    min: 0,
                    name: "面积(万㎡)",
                    nameTextStyle: {
                        color: "#fff"
                    },
                    splitNumber: 5,
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            fontSize: 14,
                            color: '#ffffff'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                }, {
                    type: 'value',
                    min: 0,
                    name: "录入量(条)",
                    position: 'right',
                    nameTextStyle: {
                        color: "#fff"
                    },
                    splitNumber: 5,
                    axisLabel: {
                        formatter: '{value}',
                        textStyle: {
                            fontSize: 14,
                            color: '#fff'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                }],
            series: [
                {
                    name: '录入面积',
                    type: 'line',
                    smooth: true,
                    data: area,
                    areaStyle: {
                        normal: {
                            // @ts-ignore
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(63, 117, 239, 0.6)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(63, 117, 239, 0)'
                                }], false),
                            shadowColor: 'rgba(63, 117, 239, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(63, 117, 239)'
                        }
                    },
                },
                {
                    name: '录入条数',
                    yAxisIndex: 1,
                    type: 'line',
                    data: num,
                    smooth: true,
                    areaStyle: {
                        normal: {
                            // @ts-ignore
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(28, 228, 239, 0.6)'
                                }, {
                                    offset: 0.8,
                                    color: 'rgba(28, 228, 239, 0)'
                                }], false),
                            shadowColor: 'rgba(0, 0, 0, 0.1)',
                            shadowBlur: 10
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: 'rgb(28, 228, 239)'
                        }
                    },
                }
            ]
        };
        myChart3.setOption(option3);
        return myChart3.resize();
    };
    HeaderModel.prototype.load = function () {
        this.reset();
        this.initMonth();
        return Promise.all([this.loadArea(),
            this.loadData()
        ]).then(function () { });
    };
    HeaderModel.prototype.reset = function () {
        this.monthSelect([]);
        this.month('');
        this.showdepalist(false);
        this.depaName('大区范围');
        this.depaId('');
        this.areaArr([]);
        this.dateArr([]);
        this.numArr([]);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasLayout = false;
        return _this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector('.index'));
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        return this.hm.load();
    };
    mModel.prototype.onResume = function () {
        this.hm.initArea(this.hm.dateArr(), this.hm.areaArr(), this.hm.numArr());
    };
    mModel.prototype.onInitComplete = function () {
        var _this = this;
        var myChart = echarts.init(this.container.querySelector('#main'));
        var myChart2;
        ajax.get("/api/first/four").then(function (d) {
            _this.hm.ribao(d.data.mdailyCount);
            _this.hm.file(d.data.mfileCount);
            _this.hm.xinxichi(d.data.minformationCount);
            _this.hm.projectFollow(d.data.mprojectCount);
        });
        // 指定图表的配置项和数据 1
        var option1 = {
            title: {
                text: '项目信息来源',
                x: 'center',
                textStyle: {
                    color: "#1ce4ef"
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                textStyle: { color: 'white' },
                orient: 'vertical',
                left: 'left',
                icon: 'circle',
                data: ['PC端', '微信端', '移动端']
            },
            series: [
                {
                    color: ['#1CE4EF', '#51B6FB', '#FFCD31'],
                    name: '访问来源',
                    type: 'pie',
                    radius: '75%',
                    center: ['55%', '55%'],
                    data: [
                        { value: 335, name: 'PC端' },
                        { value: 310, name: '微信端' },
                        { value: 234, name: '移动端' },
                    ],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };
        ajax.get("/api/first/source").then(function (d) {
            option1.series[0].data[0].value = d.data[2].PC;
            option1.series[0].data[1].value = d.data[0].WeiChat;
            option1.series[0].data[2].value = d.data[1].APP;
            myChart.setOption(option1);
        });
        // 使用刚指定的配置项和数据显示图表。
        ///////2  柱状图
        this.option2 = {
            color: ['#7584f6'],
            backgroundColor: 'rgba(0,0,0,0)',
            title: {
                text: '员工排行榜',
                textStyle: {
                    fontSize: 14,
                    fontWeight: 'normal',
                    color: "#1ce4ef"
                }
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            legend: {
                textStyle: {
                    color: 'white',
                }
            },
            grid: {
                top: '35',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: [],
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                    axisLabel: {
                        show: true,
                        interval: 0,
                        formatter: function (params) {
                            var newParamsName = "";
                            var paramsNameNumber = params.length;
                            var provideNumber = 5; //一行显示几个字
                            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
                            if (paramsNameNumber > provideNumber) {
                                for (var p = 0; p < rowNumber; p++) {
                                    var tempStr = "";
                                    var start = p * provideNumber;
                                    var end = start + provideNumber;
                                    if (p == rowNumber - 1) {
                                        tempStr = params.substring(start, paramsNameNumber);
                                    }
                                    else {
                                        tempStr = params.substring(start, end) + "\n";
                                    }
                                    newParamsName += tempStr;
                                }
                            }
                            else {
                                newParamsName = params;
                            }
                            return newParamsName;
                        },
                        textStyle: {
                            color: 'white'
                        },
                    }
                }
            ],
            yAxis: [
                {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: 'white'
                        }
                    },
                    nameTextStyle: {
                        color: "#1ce4ef",
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#89c3f8"
                        }
                    },
                }
            ],
            series: [
                {
                    type: 'bar',
                    barWidth: '60%',
                    data: [],
                }
            ]
        };
        this.hm.options2 = this.option2;
        this.hm.mychart2 = myChart2;
        ajax.get("/api/first/sign").then(function (d) {
            for (var i = 0; i < d.data[0].user.length; i++) {
                _this.option2.xAxis[0].data.push(d.data[0].user[i]);
                _this.option2.series[0].data.push(d.data[1].count[i]);
            }
            myChart2 = echarts.init(_this.container.querySelector('#main2'));
            myChart2.setOption(_this.option2);
        });
        ////// 3
        //		var option3 = {
        //			// title: {
        //			// 	text: '未来一周气温变化',
        //			// 	subtext: '纯属虚构'
        //			// },
        //			tooltip: {
        //				trigger: 'axis'
        //			},
        //			legend: {
        //				data: ['本年度绩效目标', '已完成目标'],
        //				textStyle:{//图例文字的样式
        //					color:'white',
        //					fontSize:16
        //				}
        //			},
        //			toolbox: {
        //				// show: true,
        //				// feature: {
        //				// 	dataZoom: {
        //				// 		yAxisIndex: 'none'
        //				// 	},
        //				// 	dataView: { readOnly: false },
        //				// 	magicType: { type: ['line', 'bar'] },
        //				// 	restore: {},
        //				// 	saveAsImage: {}
        //				// }
        //			},
        //			xAxis: {
        //				type: 'category',
        //				boundaryGap: false,
        //				data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        //				axisLabel:{
        //					textStyle:{color:'white'}
        //				},
        //				axisLine:{
        //							lineStyle:{
        //								color:"#89c3f8"
        //							}
        //						},
        //			},
        //			yAxis: {
        //				type: 'value',
        //				min: 0,
        //				splitNumber: 5,
        //				axisLabel: {
        //					formatter: '{value}万㎡',
        //					textStyle:{color:'white'}
        //				},
        //				axisLine:{
        //							lineStyle:{
        //								color:"#89c3f8"
        //							}
        //						},
        //			},
        //			series: [
        //				{
        //					name: '本年度绩效目标',
        //					type: 'line',
        //					data: [1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000, 1200000],
        //					markPoint: {
        //						data: [
        //							{ type: 'max', name: '最大值' },
        //							{ type: 'min', name: '最小值' }
        //						]
        //					},
        //					markLine: {
        //						data: [
        //							{ type: 'average', name: '平均值' }
        //						]
        //					},
        //					areaStyle: {
        //			            normal: {
        //			            	// @ts-ignore
        //			                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //				                    offset: 0,
        //				                    color: 'rgba(63, 117, 239, 0.6)'
        //				                }, {
        //				                    offset: 0.8,
        //				                    color: 'rgba(63, 117, 239, 0)'
        //				                }], false),
        //				                shadowColor: 'rgba(63, 117, 239, 0.1)',
        //	               				shadowBlur: 10
        //				            }
        //			        },
        //			        itemStyle: {
        //			            normal: {
        //			                color: 'rgb(63, 117, 239)'
        //			            }
        //			        },
        //				},
        //				{
        //					name: '已完成目标',
        //					type: 'line',
        //					data: [1, 6, 2, 5, 3, 2, 0],
        //					areaStyle: {
        //			            normal: {
        //			            	// @ts-ignore
        //			                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //			                    offset: 0,
        //			                    color: 'rgba(28, 228, 239, 0.6)'
        //			                }, {
        //			                    offset: 0.8,
        //			                    color: 'rgba(28, 228, 239, 0)'
        //			                }], false),
        //			                shadowColor: 'rgba(0, 0, 0, 0.1)',
        //            				shadowBlur: 10
        //			            }
        //			        },
        //			        itemStyle: {
        //			            normal: {
        //			                color: 'rgb(28, 228, 239)'
        //			            }
        //			        },
        //
        //				}
        //			]
        //		};
        //		ajax.get("/api/first/allarea").then(d => {
        //			option3.series[1].data = [];
        //       	option3.series[0].data=[]
        //	        for (let i = 0; i < 12; i++) {
        //		option3.series[0].data.push(parseFloat((d.data[0].point[0] / 10000).toFixed(2)))
        //		option3.series[1].data.push( parseFloat((d.data[0].now[i] / 10000).toFixed(2)));
        //	   }
        //			
        //			myChart3.setOption(option3);
        //		});
        this.hm.initArea(this.hm.dateArr(), this.hm.areaArr(), this.hm.numArr());
        window.onresize = function () {
            myChart.resize();
            myChart2.resize();
        };
    };
    return mModel;
}(Page));
export default mModel;
